$.module('MM.log', function () {
  function getBaseUrl() {
    return 'https://felog.memeyule.com';
  }

  var cacheKey = 'FELOG_USER_ID';
  var CLIENT_ID = 'FELOG_CLIENT_ID';
  var clientId = '';

  var defaultConfig = {
    app: 'www.2339.com',
    app_version: MM.config.version,
    env: MM.config.mode,
    user_id: '',
    // level:'info',//  info warn error
    event: 'default',
    // event_type:'',
    desc: '',
  };

  function init(opt) {
    initClientId();
    _.assign(
      defaultConfig,
      {
        group_time: Date.now(),
        group_key: MM.common.getRandomString(),
        client_id: clientId,
      },
      opt || {},
    );
    MM.core.debug('log init', defaultConfig);
    registerEvent();
  }

  function initClientId() {
    clientId = $.store.get(CLIENT_ID) || MM.common.getRandomString(8);
    $.store.set(CLIENT_ID, clientId);
  }

  function registerEvent() {
    $('body').delegate('[data-log]', 'click', function () {
      var $this = $(this);
      var str = $this.data('log');
      var data = {};
      if (str.indexOf('=') > -1) {
        data = $.parseParam(str);
      } else {
        data = {
          event: str,
        };
      }
      var defaultOpt = {
        event: $.trim($this.text()),
        desc: $.trim($this.text()).slice(0, 10), //,
        param: '',
      };
      data = _.assign(defaultOpt, data);
      send(data);
    });
  }

  /**
   *
   * @param data
   * {
   *     event,
   *     event_type,    ?
   *     param,
   *     desc
   * }
   * @private
   */
  function send(data) {
    // if(data.param) {
    //     if(typeof data.param === 'object') {
    //         data.param_obj = JSON.stringify(data.param);
    //         delete data.param;
    //     }
    // }

    // if (!defaultConfig.user_id) {
    //     var userId = MM.user.getUserId() + '';
    //     if (!userId) {
    //         userId = $.store.get(cacheKey)
    //     }
    //     if (userId) {
    //         $.store.set(cacheKey, userId);
    //         defaultConfig.user_id = userId
    //     }
    // }

    if (data.content) {
      data.content = JSON.stringify(data.content);
    }

    var d = _.assign({}, defaultConfig, data, {
      user_id: MM.user.getUserId() + '',
    });

    MM.core.debug('[felog]', JSON.stringify(d, ' ', 2));
    if (MM.config.release) {
      $.get(getBaseUrl(), {
        event: d.event,
        event_type: d.event_type,
        data: Base64.encode(JSON.stringify(d)),
      });
    }
  }

  function formatRes(res) {
    if (res && res.msg && res.message) {
      var tem = _.clone(res);
      delete tem.message;
      return tem;
    }
    return res;
  }

  return {
    init: init,
    send: send,
    formatRes: formatRes,
  };
});

$(function () {
  MM.log.init();
});
